import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Button, STYLE } from '@zocdoc/components/src/button';
import { LOCALIZED_STRINGS } from './constants';

const ViewAll = styled(Button)`
    border-bottom: 1px dotted;
    color: ${p => p.theme.practice.linkColor};
    font: inherit;
    line-height: 1;
    padding: 0;

    &:hover {
        text-decoration: none;
        border-bottom: 1px solid;
    }
`;

export default props => {
    return (
        <ViewAll
            style={STYLE.LINK}
            {...props}
        >
            <FormattedMessage {...LOCALIZED_STRINGS.ViewAll} />
        </ViewAll>
    );
};
